function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "icon/24px/simbol/google copy");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "icon/24px/simbol/google-copy",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M21.316,11.8181818 C21.316,11.1374545 21.2549091,10.4829091 21.1414545,9.85454545 L12.1,9.85454545 L12.1,13.568 L17.2665455,13.568 C17.044,14.768 16.3676364,15.7847273 15.3509091,16.4654545 L15.3509091,18.8741818 L18.4534545,18.8741818 C20.2687273,17.2029091 21.316,14.7418182 21.316,11.8181818 L21.316,11.8181818 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M12.1,21.2 C14.692,21.2 16.8650909,20.3403636 18.4534545,18.8741818 L15.3509091,16.4654545 C14.4912727,17.0414545 13.3916364,17.3818182 12.1,17.3818182 C9.59963636,17.3818182 7.48327273,15.6930909 6.72836364,13.424 L3.52109091,13.424 L3.52109091,15.9112727 C5.10072727,19.0487273 8.34727273,21.2 12.1,21.2 L12.1,21.2 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M6.72836364,13.424 C6.53636364,12.848 6.42727273,12.2327273 6.42727273,11.6 C6.42727273,10.9672727 6.53636364,10.352 6.72836364,9.776 L6.72836364,7.28872727 L3.52109091,7.28872727 C2.87090909,8.58472727 2.5,10.0509091 2.5,11.6 C2.5,13.1490909 2.87090909,14.6152727 3.52109091,15.9112727 L6.72836364,13.424 L6.72836364,13.424 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M12.1,5.81818182 C13.5094545,5.81818182 14.7749091,6.30254545 15.7698182,7.25381818 L18.5232727,4.50036364 C16.8607273,2.95127273 14.6876364,2 12.1,2 C8.34727273,2 5.10072727,4.15127273 3.52109091,7.28872727 L6.72836364,9.776 C7.48327273,7.50690909 9.59963636,5.81818182 12.1,5.81818182 L12.1,5.81818182 Z",
  id: "Shape"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/google-white.78fb5bca.svg";
export { SvgComponent as ReactComponent };